module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "admin"
  }, [_c('div', {
    staticClass: "admin-area"
  }, [_c('div', {
    staticClass: "admin-triggers"
  }, [_c('router-link', {
    staticClass: "admin-trigger",
    attrs: {
      "tag": "div",
      "active-class": "admin-trigger_active",
      "to": "/admin/users"
    }
  }, [_vm._v("Users")]), _vm._v(" "), _c('router-link', {
    staticClass: "admin-trigger",
    attrs: {
      "tag": "div",
      "active-class": "admin-trigger_active",
      "to": "/admin/apps"
    }
  }, [_vm._v("Apps")]), _vm._v(" "), _c('router-link', {
    staticClass: "admin-trigger",
    attrs: {
      "tag": "div",
      "active-class": "admin-trigger_active",
      "to": "/admin/app-groups"
    }
  }, [_vm._v("App Groups")]), _vm._v(" "), _c('router-link', {
    staticClass: "admin-trigger",
    attrs: {
      "tag": "div",
      "active-class": "admin-trigger_active",
      "to": "/admin/roles"
    }
  }, [_vm._v("Roles")]), _vm._v(" "), _c('router-link', {
    staticClass: "admin-trigger",
    attrs: {
      "tag": "div",
      "active-class": "admin-trigger_active",
      "to": "/admin/organizations"
    }
  }, [_vm._v("Organizations")]), _vm._v(" "), _c('router-link', {
    staticClass: "admin-trigger",
    attrs: {
      "tag": "div",
      "active-class": "admin-trigger_active",
      "to": "/admin/organizations-assignments"
    }
  }, [_vm._v("Organization Assignments")]), _vm._v(" "), _c('router-link', {
    staticClass: "admin-trigger",
    attrs: {
      "tag": "div",
      "active-class": "admin-trigger_active",
      "to": "/admin/team-assignments"
    }
  }, [_vm._v("Team Assignments")]), _vm._v(" "), _c('router-link', {
    staticClass: "admin-trigger",
    attrs: {
      "tag": "div",
      "active-class": "admin-trigger_active",
      "to": "/admin/teams"
    }
  }, [_vm._v("Teams")]), _vm._v(" "), _c('router-link', {
    staticClass: "admin-trigger",
    attrs: {
      "tag": "div",
      "active-class": "admin-trigger_active",
      "to": "/admin/auth-configs"
    }
  }, [_vm._v("Authorization Configurations")])], 1), _vm._v(" "), _c('div', {
    staticClass: "admin-tabs"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('router-view')], 1)], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-344a9b58!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Admin.vue
// module id = 306
// module chunks = 2